import { Navigate } from 'react-router-dom'
import { useSettingsAccess } from './settingsShared'

// Settings opens on its first tab: Company for admins, Payments for accountants.
export default function SettingsHome() {
  const can = useSettingsAccess()
  return <Navigate to={can.company ? '/settings/company' : '/settings/payments'} replace />
}
